import { render, staticRenderFns } from "./PeriodicPage.vue?vue&type=template&id=e6b0766c&scoped=true"
import script from "./PeriodicPage.vue?vue&type=script&lang=js"
export * from "./PeriodicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b0766c",
  null
  
)

export default component.exports